export const EMPTY_CART_PAGE_TEST_ID = {
  catalog: 'product-systems-catalog',
};
